module.exports = __webpack_public_path__ + "static/img/btnicon2.52354c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/btnicon2.png
// module id = urpx
// module chunks = 1